import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { UsersIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users/affiliates')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="userManagement.affiliates.page.title.affiliates" icon={UsersIcon} />,
      title: <Translation id="userManagement.affiliates.page.title.affiliates" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
